import { render, staticRenderFns } from "./PartnersView.vue?vue&type=template&id=11a44f34&scoped=true"
import script from "./PartnersView.vue?vue&type=script&lang=ts"
export * from "./PartnersView.vue?vue&type=script&lang=ts"
import style0 from "./PartnersView.vue?vue&type=style&index=0&id=11a44f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a44f34",
  null
  
)

export default component.exports